module.exports = __webpack_public_path__ + "carousel_05_img_04.png?8a62dc0f9f88b59656b4503ed3f0bd57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel_05_img_04.png
// module id = 165
// module chunks = 0